var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 11H12C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V28C11 28.2652 11.1054 28.5196 11.2929 28.7071C11.4804 28.8946 11.7348 29 12 29H28C28.2652 29 28.5196 28.8946 28.7071 28.7071C28.8946 28.5196 29 28.2652 29 28V12C29 11.7348 28.8946 11.4804 28.7071 11.2929C28.5196 11.1054 28.2652 11 28 11ZM16.339 26.337H13.667V17.747H16.339V26.337ZM15.003 16.574C14.5924 16.574 14.1987 16.4109 13.9084 16.1206C13.6181 15.8303 13.455 15.4366 13.455 15.026C13.455 14.6154 13.6181 14.2217 13.9084 13.9314C14.1987 13.6411 14.5924 13.478 15.003 13.478C15.4136 13.478 15.8073 13.6411 16.0976 13.9314C16.3879 14.2217 16.551 14.6154 16.551 15.026C16.551 15.4366 16.3879 15.8303 16.0976 16.1206C15.8073 16.4109 15.4136 16.574 15.003 16.574ZM26.338 26.337H23.669V22.16C23.669 21.164 23.651 19.883 22.281 19.883C20.891 19.883 20.68 20.969 20.68 22.09V26.338H18.013V17.748H20.573V18.922H20.61C20.965 18.247 21.837 17.535 23.134 17.535C25.838 17.535 26.337 19.313 26.337 21.627V26.337H26.338Z",
    fill: "url(#paint0_linear_5611_41972)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5611_41972",
    x1: 11,
    y1: 20,
    x2: 29,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiIcon);
export default __webpack_public_path__ + "static/media/li-icon.2b28b4e64e6bc3d48b42b14e797bc3b6.svg";
export { ForwardRef as ReactComponent };